import React, { useEffect, useState } from 'react';

import KOGBoxGridCheckbox, { IOptionGridCheckbox } from '@/main/components/shared/boxGridCheckbox/boxGridCheckbox';
import ResultNotFoundComponent from '@/main/components/shared/resultNotFound/resultNotFoundComponent';
import { distributionRegionApi } from '@/main/api';
import { KeyValue } from '@/main/models/common';
import { getTranslateByKey } from '@/main/services/utils';

import * as StyleShared from '@/main/components/shared/styles';
import * as S from './styles';

interface IDistributionInfoProps {
  watcherCountry: KeyValue | null;
  dataDitribution: string[];
  setDataDitribution: (data: string[]) => void;
}

function DistributionInfo({
  watcherCountry,
  dataDitribution,
  setDataDitribution
}: IDistributionInfoProps) {
  const [optionsDistribution, setOptionsDistribution] = useState<IOptionGridCheckbox[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  function loadOptions(countrySelected: KeyValue | null) {
    if (!countrySelected) {
      setOptionsDistribution([]);
      setDataDitribution([]);
      return;
    }
    setIsLoading(true);
    distributionRegionApi
      .getDistributions({
        guidCountry: String(countrySelected.key),
      })
      .then(response => {
        const { result } = response.data;
        const formattedOptions = result.map(option => {
          return {
            id: option.guid,
            elements: [
              { content: option.name, width: '55%' },
              { content: option.zipCodeStart, width: '22.5%' },
              { content: option.zipCodeEnd, width: '22.5%' }
            ]
          };
        }) as IOptionGridCheckbox[];



        setOptionsDistribution(formattedOptions);
      })
      .finally(() => { setIsLoading(false); });
  }


  useEffect(() => {
    loadOptions(watcherCountry);
  }, [watcherCountry]);

  const rowHeaders = [
    getTranslateByKey('information.regionName'),
    getTranslateByKey('information.initialZipCode'),
    getTranslateByKey('information.finalZipCode')
  ];

  return (
    <S.Container>
      <StyleShared.HeaderText>
        {getTranslateByKey('information.distributionInfo')}
      </StyleShared.HeaderText>
      {isLoading ?
        <StyleShared.SpinnerLoading /> :
        (watcherCountry && optionsDistribution.length > 0) ?
          <KOGBoxGridCheckbox
            rowHeaders={rowHeaders}
            options={optionsDistribution}
            optionsSelected={dataDitribution}
            setOptionsSelected={setDataDitribution}
          /> :
          <ResultNotFoundComponent
            messageCustom={getTranslateByKey('supplier.notFoundDistributionRegion', true)}
          />
      }
    </S.Container>
  );
}

export default DistributionInfo;
